import { FaqAccordionItems } from '@app/widgets';

export const NATIVE_BUILDS_FAQS: FaqAccordionItems[] = [
  {
    question: 'What platforms can I build for?',
    answer: [
      'Native Builds supports building for Android, iOS, and Web.',
      'For iOS, we support Simulator, Development, Ad Hoc, App Store, and Enterprise builds.',
      'For Android, we support Debug, Release, and custom build types.',
      'Web builds can be distributed as <a href="/live-updates/">Live Updates</a> directly to your users.',
    ].join(' '),
  },
  {
    question: 'How long does a build take?',
    answer: [
      'Build times vary depending on your project size and complexity.',
      'On average, Android builds take approximately 2 minutes and 50 seconds, while iOS builds complete in around 2 minutes and 35 seconds.',
      'We continuously optimize our infrastructure to provide fast and reliable build times.',
    ].join(' '),
  },
  {
    question: 'Is my source code stored on our servers?',
    answer: [
      'No, we do not permanently store your source code on our servers.',
      'Your repository is only cloned at build time into a temporary, isolated virtual machine.',
      'Once the build job is finished, the VM and all its contents are immediately destroyed.',
      'This works the exact same way as any other CI/CD platform like GitHub Actions, GitLab CI, or Jenkins.',
      'Additionally, no person ever has access to those files at build time\u2014the build process is fully automated and isolated.',
    ].join(' '),
  },
  {
    question: 'Can I use custom Gradle or Xcode configurations?',
    answer: [
      "Yes! Native Builds supports custom build configurations through your project's existing Gradle and Xcode files.",
      'You can also use environment variables to customize build behavior.',
    ].join(' '),
  },
  {
    question: 'How are signing certificates stored securely?',
    answer: [
      'All signing certificates and secrets are encrypted at rest and in transit.',
      "They're stored in isolated, secure storage and are never exposed in build logs or accessible to other customers.",
    ].join(' '),
  },
  {
    question: 'Can I trigger builds from my CI/CD pipeline?',
    answer: [
      'Yes, you can trigger builds using our <a href="https://capawesome.io/cloud/cli/" target="_blank">CLI tool</a> or <a href="https://capawesome.io/cloud/api/" target="_blank">API</a>.',
      'You can also use Capawesome Cloud Automations to automatically trigger builds based on rules like branch names or commit message patterns.',
      'This enables a complete automated CI/CD workflow.',
    ].join(' '),
  },
  {
    question: 'Is Git LFS supported?',
    answer: [
      'Yes, Git LFS (Large File Storage) is fully supported.',
      'If your repository uses Git LFS to manage large files such as binaries or assets, they will be automatically fetched during the build process.',
    ].join(' '),
  },
  {
    question: 'Do you offer unlimited build minutes?',
    answer: [
      'Yes, we offer unlimited build minutes with our custom and enterprise plans.',
      'Visit our <a href="/pricing/">Pricing</a> page to learn more and request a plan that fits your needs.',
    ].join(' '),
  },
];
